import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=2163626c&scoped=true&"
import script from "./Identification.vue?vue&type=script&lang=js&"
export * from "./Identification.vue?vue&type=script&lang=js&"
import style0 from "./Identification.vue?vue&type=style&index=0&id=2163626c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163626c",
  null
  
)

export default component.exports